import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@paulownia/shared/components/ui/dialog';
import { Order, Product } from '@paulownia/shared/types';
import { ValidationQueue } from './ValidationQueue';
import { AlertTriangle } from 'lucide-react';

interface ValidationQueueDialogProps {
  isOpen: boolean;
  onClose: () => void;
  orders: Order[];
  products: Product[];
}

export function ValidationQueueDialog({
  isOpen,
  onClose,
  orders,
  products,
}: ValidationQueueDialogProps) {
  const awaitingCount = orders.filter(o => o.status === 'awaiting_validation').length;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg max-h-[90vh] flex flex-col p-0 gap-0">
        <DialogHeader className="px-4 py-3 border-b bg-amber-50 flex-shrink-0">
          <DialogTitle className="flex items-center gap-2 text-amber-800">
            <AlertTriangle className="h-5 w-5" />
            Validation des commandes
            {awaitingCount > 0 && (
              <span className="text-sm font-normal text-amber-600">
                ({awaitingCount} en attente)
              </span>
            )}
          </DialogTitle>
        </DialogHeader>

        <div className="flex-1 min-h-0 overflow-auto">
          <ValidationQueue
            orders={orders}
            products={products}
            onComplete={onClose}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
